import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getUsers, type AppUser } from '../api';

// Vælg medarbejder. Værdien er medarbejderens id (som tekst, '' = ingen) — ikke navnet, så et
// navneskift ikke river opgaverne løs (Kennith 2026-10-14).
interface Props {
  value: string;
  onChange: (id: string) => void;
  className?: string;
  // "Standard medarbejder" fra Indstillinger gemmes som navn — vælges automatisk når listen er hentet
  defaultName?: string;
  // Vis advarsel: der skal altid vælges en medarbejder
  missing?: boolean;
}

export default function UserSelect({ value, onChange, className = 'input', defaultName, missing }: Props) {
  const { t } = useTranslation();
  const [users, setUsers] = useState<AppUser[]>([]);

  useEffect(() => {
    getUsers().then(list => {
      setUsers(list);
      if (!value && defaultName) {
        const match = list.find(u => u.name === defaultName);
        if (match) onChange(String(match.id));
      }
    });
    // Kun ved mount: standard-medarbejderen er et udgangspunkt, ikke noget der skal tvinges igen
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showWarning = missing && !value;
  return (
    <div>
      <select className={`${className}${showWarning ? ' border-rose-400' : ''}`} value={value}
        onChange={e => onChange(e.target.value)}>
        <option value="">—</option>
        {users.map(u => <option key={u.id} value={String(u.id)}>{u.name}</option>)}
      </select>
      {showWarning && <p className="text-xs text-rose-700 mt-1">{t('events.employee_required')}</p>}
    </div>
  );
}
